<template>
  <div class="drop-file-container" @drop="uploadFile" @dragenter.prevent @dragover.prevent>
    <div class="file-upload-container">
      <div>Drop File Here</div>
    </div>
  </div>
</template>

<script>

import store from '@/store'

export default {
  name: 'DropSalesOrderFile',
  props: ['sono'],
  file: null,
  methods: {
    uploadFile (e) {
      // Prevent default behavior.
      e.stopPropagation()
      e.preventDefault()

      // Get the file.
      const file = e.dataTransfer.files[0]

      // Create a form to submit.
      const formData = new FormData()
      formData.append('file', file)

      // Dispatch the upload action.
      const payload = {'salesOrderNumber': this.sono, 'formData': formData}
      store.dispatch('sales_orders/uploadRelatedSalesOrderFile', payload).then(() => {
        store.dispatch('sales_orders/fetchRelatedSalesOrderFiles', this.sono.trim())
      })
    }
  }
}
</script>

<style scoped>
  .drop-file-container {
    height: 10em;
    width: 10em;
  }
  .file-upload-container {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px dashed black;
  }
  .file-upload-container:hover {
    background-color: #f1f1f1;
  }
</style>
